<template>
  <div class="lection-cla">
    <a-space size="large">
      <a-button type="primary" @click="showAdd">添加二級分類</a-button>
<!--      <a-button type="primary" @click="oneDia = true;">添加一級分類</a-button>-->
      <a-select v-model="oneCla" style="width: 120px" @change="claChange">
        <a-select-option :key="index" v-for="(item,index) in oneList" :value="item.id">{{item.desc}}</a-select-option>
      </a-select>
    </a-space>
      <a-table
          :dataSource="list"
          :loading="loading"
          rowKey="id"
          :pagination="false">
        <a-table-column
            align="center"
            title="分類名稱"
            dataIndex="desc">

        </a-table-column>
        <a-table-column
            align="center"
            title="上傳時間">
          <template slot-scope="row,item,$index">
            {{ item.addTime | trans-date }}
          </template>
        </a-table-column>
        <a-table-column
            title="分類ID"
            align="center"
            dataIndex="id">

        </a-table-column>
        <a-table-column
            align="center"
            title="操作">
          <template slot-scope="row,item,index">
            <a-button style="margin-right:10px;" @click="del(item)" size="small">刪除</a-button>
            <a-button @click="edit(item)" size="small">編輯</a-button>
          </template>
        </a-table-column>
      </a-table>
      <a-modal
          :title="title"
          :visible="addDia"
          @ok="action"
          :confirmLoading="confirmLoading"
          @cancel="hideAdd"
          cancelText="取消"
          okText="提交"
      >
        <a-select placeholder="請選擇一級分類" v-model="selectCla" style="width: 200px;margin-bottom:20px;" @change="claChange">
          <a-select-option :key="index" v-for="(item,index) in oneList" :value="item.id">{{item.desc}}</a-select-option>
        </a-select>
        <br>
        <a-input style="width:200px;" size="large" placeholder="請輸入分類名稱" v-model.trim="text"/>
      </a-modal>
    <a-modal
        title="添加一級分類"
        :visible="oneDia"
        @ok="oneAction"
        :confirmLoading="confirmLoading"
        @cancel="hideAdd"
        cancelText="取消"
        okText="提交"
    >
      <a-input style="width:120px;" size="large" placeholder="請輸入一級分類名稱" v-model.trim="oneText"/>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectCla:undefined,
      oneText:undefined,
      oneDia:false,
      oneCla:undefined,
      loading: false,
      addDia: false,
      confirmLoading: false,
      title: '',
      text: '',
      list: [],
      editor: false,
      editId: '',
      oneList:[]
    }
  },
  methods: {
    claChange(val) {
      this.oneCLa = val;
      this.getList();
    },
    getOneCla(){
      let self = this;
      this.$http({
        method: 'get',
        url: '/manager/category/selectAll',
      }).then(res=>{
        this.oneList = res.data;
        self.oneCla = this.oneList.length ? this.oneList[0].id : undefined
        this.getList();
      })
    },
    showAdd() {
      this.title = '添加經文分類'
      this.addDia = true;
      this.editor = false;
      this.text = ''
    },
    getList() {
      let self = this;
      this.loading = true;
      this.$http({
        method: 'get',
        url: '/manager/type/scripture/list?id=' + this.oneCla,
      }).then(function (res) {
        self.loading = false;
        if (res.data && res.data.length) {
          self.list = res.data;
        } else {
          self.list = []
        }
      }).catch(err => {
        self.loading = false;
      })
    },
    action() {
      let self = this;
      let url, data;
      if(!self.selectCla){
        this.$Message.warning('請選擇一級分類')
        return false;
      }
      if (self.text === '') {
        this.$Message.warning('分類內容不能為空')
        return false;
      }
      if (this.editor) {
        url = '/manager/type/scripture/update';
        data = {
          desc: self.text,
          id: self.editId,
          fistCategory:self.selectCla
        }
      } else {
        url = '/manager/type/scripture/add';
        data = {
          fistCategory:self.selectCla,
          desc: self.text
        }
      }
      self.confirmLoading = true;
      this.$http({
        method: 'post',
        url: url,
        data: data
      }).then(function (res) {
        self.$Message.success('操作成功')
        self.confirmLoading = false;
        self.addDia = false
        self.editId = ''
        self.editor = false;
        self.text = '';
        self.selectCla = undefined;
        self.title = ''
        self.getList()
      }).catch(err => {
        self.confirmLoading = false;
      })
    },
    oneAction() {
      let self = this;
      let url, data;
      if (self.oneText === '') {
        this.$Message.warning('分類內容不能為空')
        return false;
      }
      url = '/manager/category/add';
      data = {
        desc: self.oneText
      }
      self.confirmLoading = true;
      this.$http({
        method: 'post',
        url: url,
        data: data
      }).then(function (res) {
        self.$Message.success('操作成功')
        self.confirmLoading = false;
        self.oneDia = false
        self.oneText = '';
        self.getOneCla()
      }).catch(err => {
        self.confirmLoading = false;
      })
    },
    hideAdd() {
      this.addDia = false;
      this.text = ''
      this.title = ''
      this.selectCla = undefined;
    },
    edit(item) {
      let self = this;
      this.title = '編輯經文分類'
      this.editor = true;
      this.editId = item.id;
      this.text = item.desc;
      this.selectCla = item.firstCategory * 1;
      this.addDia = true;
    },
    del(item) {
      let self = this;
      this.$Confirm({
        title: '確定刪除該分類嗎？',
        onOk() {
          self.$http({
            method: 'post',
            url: '/manager/type/scripture/delete',
            data: {
              id: item.id
            }
          }).then(function (res) {
            self.$Message.success('操作成功')
            self.getList()
          }).catch(err => {
          })
        },
        onCancel() {
        }
      })
    }
  },
  mounted() {
  },
  created() {
    this.$emit('breadcrumbChange', ['典籍管理', '典籍分類管理'])
    this.getOneCla()
  },
}
</script>
<style lang="less">
div.lection-cla {
  text-align: left;
}
</style>